/* eslint-disable class-methods-use-this */
import {
  copy,
  copyAsset,
  deleteVideo,
  formatDate,
  getAccount,
  getEnvironmentUrlApp,
  getLabels,
  getLibraryItems,
  getLibraryItemsByLabel,
  getSharedVideos,
  getSmallestBreakpointForWidth,
  getTeamsWithContent,
  getTeamFolders,
  getTrialInfo,
  getVideoDetails,
  getVideoTranscript,
  previewVideo,
} from '@/functions';

type NonUndefined<T> = T extends undefined ? never : T;

export default class VideoLibraryApi {
  copyAsset(
    environment: NonUndefined<Parameters<typeof copyAsset>[0]>,
    authToken: Parameters<typeof copyAsset>[1],
    type: Parameters<typeof copyAsset>[2],
    userId: Parameters<typeof copyAsset>[3],
    videoId: Parameters<typeof copyAsset>[4],
  ) {
    return copyAsset(environment, authToken, type, userId, videoId);
  }

  copyText(text: Parameters<typeof copy.copyText>[0]) {
    return copy.copyText(text);
  }

  deleteVideo(
    authToken: Parameters<typeof deleteVideo>[0],
    environment: NonUndefined<Parameters<typeof deleteVideo>[1]>,
    videoId: Parameters<typeof deleteVideo>[2],
  ) {
    return deleteVideo(authToken, environment, videoId);
  }

  formatDate(unformattedDate: Parameters<typeof formatDate>[0]) {
    return formatDate(unformattedDate);
  }

  getAccount(
    authToken: Parameters<typeof getAccount>[0],
    environment: NonUndefined<Parameters<typeof getAccount>[1]>,
  ) {
    return getAccount(authToken, environment);
  }

  getEnvironmentUrlApp(environment: NonUndefined<Parameters<typeof getEnvironmentUrlApp>[0]> = '') {
    return getEnvironmentUrlApp(environment);
  }

  getLabels(
    authToken: Parameters<typeof getLabels>[0],
    environment: NonUndefined<Parameters<typeof getLabels>[1]>,
  ) {
    return getLabels(authToken, environment);
  }

  getLibraryItems(
    authToken: Parameters<typeof getLibraryItems>[0],
    environment: Parameters<typeof getLibraryItems>[1],
    searchTerms: NonUndefined<Parameters<typeof getLibraryItems>[2]>,
  ) {
    return getLibraryItems(authToken, environment, searchTerms);
  }

  getLibraryItemsByLabel(
    authToken: Parameters<typeof getLibraryItemsByLabel>[0],
    environment: Parameters<typeof getLibraryItemsByLabel>[1],
    tagId: Parameters<typeof getLibraryItemsByLabel>[2],
  ) {
    return getLibraryItemsByLabel(authToken, environment, tagId);
  }

  getSharedVideos(
    authToken: Parameters<typeof getSharedVideos>[0],
    environment: NonUndefined<Parameters<typeof getSharedVideos>[1]>,
    clientGroupId: Parameters<typeof getSharedVideos>[2],
    folderId: NonUndefined<Parameters<typeof getSharedVideos>[3]> = null,
  ) {
    return getSharedVideos(authToken, environment, clientGroupId, folderId);
  }

  getSmallestBreakpointForWidth(
    width: Parameters<typeof getSmallestBreakpointForWidth>[0],
    options: NonUndefined<Parameters<typeof getSmallestBreakpointForWidth>[1]> = {},
  ) {
    return getSmallestBreakpointForWidth(width, options);
  }

  getTeamFolders(
    authToken: Parameters<typeof getTeamFolders>[0],
    environment: NonUndefined<Parameters<typeof getTeamFolders>[1]>,
    teamId: Parameters<typeof getTeamFolders>[2],
  ) {
    return getTeamFolders(authToken, environment, teamId);
  }

  getTeamsWithContent(
    authToken: Parameters<typeof getTeamsWithContent>[0],
    environment: NonUndefined<Parameters<typeof getTeamsWithContent>[1]>,
  ) {
    return getTeamsWithContent(authToken, environment);
  }

  getTrialInfo(
    authToken: Parameters<typeof getTrialInfo>[0],
    environment: NonUndefined<Parameters<typeof getTrialInfo>[1]>,
  ) {
    return getTrialInfo(authToken, environment);
  }

  getVideoDetails(
    authToken: Parameters<typeof getVideoDetails>[0],
    environment: NonUndefined<Parameters<typeof getVideoDetails>[1]>,
    videoId: Parameters<typeof getVideoDetails>[2],
  ) {
    return getVideoDetails(authToken, environment, videoId);
  }

  getVideoTranscript(
    authToken: Parameters<typeof getVideoTranscript>[0],
    environment: NonUndefined<Parameters<typeof getVideoTranscript>[1]>,
    videoId: Parameters<typeof getVideoTranscript>[2],
  ) {
    return getVideoTranscript(authToken, environment, videoId);
  }

  previewVideo(
    authToken: Parameters<typeof previewVideo>[0],
    environment: NonUndefined<Parameters<typeof previewVideo>[1]>,
    videoId: Parameters<typeof previewVideo>[2],
  ) {
    return previewVideo(authToken, environment, videoId);
  }
}
